import { api } from '@/api/appGatewayServerApi'
import { checkInMaintenance } from '@/utils/maintenance'

export async function checkMaintenance(): Promise<boolean> {
  let isMaintenance = false
  //メンテナンスチェックするだけの為のリクエスト（503の場合catchで処理する）
  await api()
    .maintenance.allCheck()
    .catch((e) => {
      if (checkInMaintenance(e)) {
        isMaintenance = true
      }
    })

  return isMaintenance
}
